import React from 'react';
import {Col, Row} from 'react-bootstrap';
import DisplayItCard from './display-it-card.jsx';
import failed from '../../../assets/img/performances/FAILED@2x.png';
import unmarked from '../../../assets/img/performances/UNMARKED_2.png';
import nodata from '../../../assets/img/performances/NoData-Objectives.svg';
import passedBig from '../../../assets/img/performances/DisplayIT-PassedIcon.png';
import failedBig from '../../../assets/img/performances/DisplayIT-FailedIcon.png';
import passedBigDisabled from '../../../assets/img/performances/DisplayIT-PassedIcon-greyscale.png';
import failedBigDisabled from '../../../assets/img/performances/DisplayIT-FailedIcon-greyscale.png';
import passed from '../../../assets/img/performances/PASSED@2x.png';
import passedDisabled from '../../../assets/img/performances/PASSED-GREYSCALE@2x.png';
import failedDisabled from '../../../assets/img/performances/FAILED-GREYSCALE@2x.png';

const DisplayItTable = ({
  name, active, display_outlets: displayOutlets, points_awarded: pointsAwarded
}) => {
  const lastMonth = displayOutlets[displayOutlets.length - 1];

  function getYN(outlet) {
    switch (outlet.display_passed_yn) {
      case 'Y':
        return (
          <img className="article-image" src={active ? passed : passedDisabled} height='25'/>
        );
      case 'N':
        return (
          <img className="article-image" src={active ? failed : failedDisabled} height='25'/>
        );
      default:
        return (
          <img className="article-image" src={unmarked} height='25'/>
        );
    }
  }

  function passedOrFailed(YN) {
    switch (YN) {
      case 'Y':
        switch (active) {
          case true:
            return passedBig;
          case false:
            return passedBigDisabled;
          default:
            return passedBig;
        }
      case 'N':
        switch (active) {
          case true:
            return failedBig;
          case false:
            return failedBigDisabled;
          default:
            return failedBig;
        }
      default:
        return nodata;
    }
  }

  function cardTitle(title) {
    return (
      <div className="text-center card-title">
        {title}
      </div>
    );
  }


  function lastMonthHeader() {
    let status;
    if (lastMonth.display_passed_yn === 'Y') {
      status = 'Passed';
    } else if (lastMonth.display_passed_yn === 'N') {
      status = 'Failed';
    } else {
      status = 'Not Assessed';
    }

    return (
      <div>
        {cardTitle(lastMonth.label)}
        <div className="text-center text-big">
          <b>{status}</b>
        </div>
      </div>
    );
  }

  function lastMonthContent() {
    return (
      <div className="center-block">
        <img className="article-image" src={passedOrFailed(lastMonth.display_passed_yn)}/>
      </div>
    );
  }

  function totalPointsToDateContent() {
    return (
      <div className={active ? 'text-big-center active' : 'text-big-center closed'}>
        {pointsAwarded}
      </div>
    );
  }

  function previouslyContent() {
    return (
      <div className="text-left">
        {displayOutlets.map((outlet, index) => (
          <div className='one-line' id={index} key={outlet.id}>
            {getYN(outlet)}
            {outlet.label}
          </div>
        ))
        }
      </div>
    );
  }

  function monthlyPointsContent() {
    const left = 'text-left col-md-6 col-sm-6 col-xs-6';
    const passedIfActive = active ? 'passed ' : '';
    const failedIfActive = active ? 'failed ' : '';
    return (
      <div className="text-center">
        <div>
          {displayOutlets.map((outlet, index) => (
            <Row className='one-line' id={index} key={outlet.id}>
              <Col className="text-right col-md-6 col-sm-6 col-xs-6">
                {outlet.label}
              </Col>
              <Col className={outlet.display_passed_yn === 'Y' ? `${passedIfActive}${left}` : `${failedIfActive}${left}`}>
                {outlet.points}
              </Col>
            </Row>
          ))
          }
        </div>
      </div>
    );
  }

  return (
    <div>
      <Row className="performance-table performance-label">
        <div className="flex-container">
          {!active && <div className="locked" />}
          <div className="display-it-objective-name">
            <b>{name}</b>
          </div>
        </div>
      </Row>
      <Row className='performance-box'>
        <Col className="last-month col-md-3 col-sm-3 col-xs-3" style={ { minHeight: '1em' } }>
          <DisplayItCard header={lastMonthHeader()} content={lastMonthContent()} />
        </Col>
        <Col className="previously col-md-3 col-sm-3 col-xs-3" style={ { minHeight: '1em' } }>
          <DisplayItCard header={cardTitle('PREVIOUSLY')} content={previouslyContent()} />
        </Col>
        <Col className="total-points-to-date col-md-3 col-sm-3 col-xs-3" style={ { minHeight: '1em' } }>
          <DisplayItCard header={cardTitle('TOTAL POINTS TO DATE')} content={totalPointsToDateContent()} />
        </Col>
        <Col className="monthy-points col-md-3 col-sm-3 col-xs-3" style={ { minHeight: '1em' } }>
          <DisplayItCard header={cardTitle('MONTHLY POINTS')} content={monthlyPointsContent()} />
        </Col>
      </Row>
    </div>
  );
};

export default DisplayItTable;



// WEBPACK FOOTER //
// ./src/components/store-performance/display-it/display-it-table.jsx